import { useState } from 'react'
import Cookies from 'js-cookie'
import { coreInstance, feedbacksInstance } from 'shared/axios'

export const useToken = () => {
  const [token, setToken] = useState(() => {
    if (import.meta.env.PROD) {
      localStorage.removeItem('token')

      return Cookies.get('token')
    } else {
      return localStorage.getItem('token')
    }
  })

  const handleTokenSet = (newToken: string) => {
    if (import.meta.env.PROD) {
      Cookies.set('token', newToken)
    } else {
      localStorage.setItem('token', newToken)
    }

    coreInstance.defaults.headers['Authentication'] = newToken
    feedbacksInstance.defaults.headers['Authentication'] = newToken
    setToken(newToken)
  }

  const removeToken = () => {
    if (import.meta.env.PROD) {
      Cookies.remove('token')
    } else {
      localStorage.removeItem('token')
    }

    feedbacksInstance.defaults.headers['Authentication'] = null
    coreInstance.defaults.headers['Authentication'] = null
    setToken(null)
  }

  return { token, setToken: handleTokenSet, removeToken }
}
